var $ = require('jquery');
var ismobile = require('ismobile');
var getWW = require('ww');
var getWH = require('wh');
var phplog = require('phplog');

// alert(ismobile)

var canResize = true,
	hasRequestedResize = false,
	resize = 'resize',
	namespace = 'cube',
	ww = getWW(),
	wh = getWH(),
	prev_w = -100,
	prev_h = -100,
	diff_w = -100,
	diff_h = -100,
	istb = false,
	iskb = false,
	isph = false,
	$window = $(window);

// limit call to resizeHandler
var onResize = function() {
	if (canResize) {
		canResize = false;
		resizeHandler();
		setTimeout(function() {
			if (hasRequestedResize) {
				hasRequestedResize = false;
				resizeHandler();
			}
			canResize = true;
		}, 300);
	} else {
		hasRequestedResize = true;
	}
};

var resizeHandler = function() {
	ww = getWW();
	wh = getWH();

	diff_w = Math.abs(prev_w - ww);
	diff_h = Math.abs(prev_h - wh);
	// console.log('diff_w', diff_w);
	// console.log('diff_h', diff_h);

	// phplog('diff_w: '+diff_w);
	// phplog('diff_h: '+diff_h);

	// trigger main resize everytime
	$window.trigger(namespace+':'+resize+'all', [ww, wh]);
	// trigger resizeexcepttoolbar resizewotb
	istb = ismobile && diff_w == 0 && diff_h > 0 && diff_h < 100;
	// console.log('istb', istb);
	if ( !istb ) {
		$window.trigger(namespace+':'+resize+'wotb', [ww, wh]);
	}
	// trigger resizeexceptkeyboard resizewokb
	iskb = ismobile && diff_w == 0 && diff_h > 100;
	// console.log('iskb', iskb);
	if ( !istb ) {
		$window.trigger(namespace+':'+resize+'wokb', [ww, wh]);
	}
	// trigger resizeexcepttoolbarandkeyboard resizewoall
	if ( !istb && !iskb ) {
		// console.log('trigger resizefull');
		$window.trigger(namespace+':'+resize+'woall', [ww, wh]);
	}

	isph = !ismobile || diff_w > 0;

	if ( isph ) {
		// console.log('trigger resizefull');
		$window.trigger(namespace+':'+resize+'real', [ww, wh]);
	}

	prev_w = ww;
	prev_h = wh;
};
$window.on(resize, onResize);
$window.trigger(resize);

